import {objectToCamelCase, objectToSnakeCase} from '@/services/utils'
import User from '@/services/users'

import api from './api'
import templates from './templates'
import options from './options'

export default class Message {
  static api = api.create(Message)
  static templates = templates
  static options = options
  static readOnlyFields = ['id', 'sender', 'senderRef', 'isUnread', 'lastEdited']

  constructor({
    id = '',
    sender = null,
    senderRef = null,
    request = null,
    stipendRequest = null,
    text = '',
    note = '',
    isUnread = null,
    category = '',
    datetimeCreated = null,
    lastEdited = null,
    messagedOn = '',
    messageType = null,
    status = null,
    sendDatetime = null,
  } = {}) {
    Object.assign(this, {
      id,
      sender,
      senderRef: senderRef ? User.fromAPI(senderRef) : null,
      request,
      stipendRequest,
      text,
      note,
      isUnread,
      category,
      datetimeCreated: datetimeCreated ? datetimeCreated : new Date().toISOString(),
      lastEdited,
      messagedOn: messagedOn ? messagedOn : new Date().toISOString(),
      messageType,
      status,
      sendDatetime,
    })
  }

  static create(opts) {
    return new Message(opts)
  }

  static fromAPI(json) {
    return new Message(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The readOnlyFields are always excluded.
   **/
  static toAPI(message, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = message[field]
      })
    } else {
      data = message
    }

    //
    excludeFields = [...Message.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    if (message.messagedOn) {
      data.messagedOn = message.messagedOn
    }

    return objectToSnakeCase(data)
  }
  static checkIsInstance(obj, name) {
    if (!(obj instanceof Message)) {
      throw Error(`${name} must be an instance of the Message class.`)
    }
  }
}
